<template>
    <div class="parking-filter__wrapper">
        <form
            :class="['parametric-filters__form', {'is-processing': isProc}]"
            ref="form"
            @change="change"
            @reset.prevent="reset">

            <div class="parking-filter__item parking-filter__building" v-if="buildings">
                <div class="parking-filter__item-title">Корпус</div>
                    <Select
                        :list="filters.buildings"
                        :closeOnSelect="true"
                        ref='buildingWrapper'
                        @selectric-select="selectrichange($event)"
                    />
            </div>

            <!-- слайдер для цен на паркинги -->

            <div v-show="parkingType == 'parking'"
                 class="parking-filter__item">
                <div class="parking-filter__item-title">Стоимость машиноместа, руб.</div>

                <Slider
                    name="price"
                    :to="priceMax"
                    :from="priceMin"
                    ref="sliderPrice"/>
            </div>

            <!-- слайдер для цен на кладовые -->

            <div v-show="parkingType == 'pantry'"
                 class="parking-filter__item">
                <div class="parking-filter__item-title">Стоимость кладовой, руб.</div>

                <Slider
                    name="pricePantry"
                    :to="pricePantryMax"
                    :from="pricePantryMin"
                    ref="sliderPricePantry"/>
            </div>

            <div class="parking-filter__item">
                <div class="parking-filter__item-title">Площадь, м2</div>

                <!-- слайдер площади для паркингов -->

                <Slider v-show="parkingType == 'parking'"
                    :name="'area'"
                    :to="sliders.area.to"
                    :from="sliders.area.from"
                    ref="sliderArea"/>

                <!-- слайдер площади для кладовых -->

                <Slider v-show="parkingType == 'pantry'"
                    :name="'areaPantry'"
                    :to="sliders.areaPantry.to"
                    :from="sliders.areaPantry.from"
                    ref="sliderAreaPantry"/>
            </div>

            <div class="parametric-filters__group">
                <button class="parametric-filters__reset" type="reset">
                    <div class="parametric-filters__reset-text">Сбросить параметры</div>
                    <img :src="'/images/visual/parking/reset.svg'" alt="Сбросить параметры">
                </button>
            </div>
        </form>
    </div>
</template>

<style lang="css">
    @import "../range-slider/ion.rangeSlider.css";
    @import "../range-slider/ion.rangeSlider.skinHTML5.css";
</style>
<style lang='scss'>
    @import "../range-slider/range-slider.scss";
    @import "./ParkingListFilter.scss";
</style>


<script>
import {mapActions, mapGetters} from 'vuex';
import ButtonCheckbox from 'components/button-checkbox/ButtonCheckbox.vue';
import initSliders from '../range-slider/config/paramParking';
import Observer from 'common/scripts/observer';
// import SingleSelect from 'components/forms/many-select/many-select.vue';
import Select from 'components/forms/select/select-parking.vue';
import Slider from '../range-slider/range-slider.vue';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    data() {
        return {
            // pricePantryMin: '',
            // pricePantryMax: '',
            isOpen  : true,
            selected: ''
        };
    },

    components: {
        ButtonCheckbox,
        Select,
        // SingleSelect,
        Slider
    },

    computed: {
        ...mapGetters({
            isReady    : 'GET_IS_READY',
            isProc     : 'GET_IS_PROCESSING',
            filters    : 'GET_FILTERS',
            sliders    : 'GET_SLIDERS',
            dataStep   : 'GET_DATA_STEP',
            parkingType: 'GET_PARKING_TYPE',
            buildings  : 'GET_BUILDING'
        }),

        priceMin() {
            return Utils.convertToDigit(this.sliders.price.from);
        },

        priceMax() {
            return Utils.convertToDigit(this.sliders.price.to);
        },

        pricePantryMin() {
            return Utils.convertToDigit(this.sliders.pricePantry.from);
        },

        pricePantryMax() {
            return Utils.convertToDigit(this.sliders.pricePantry.to);
        }
    },

    watch: {
        isReady() {
            this.$nextTick(() => {
                initSliders(this.$refs, this.sliders);
                this.initFilter({form: this.$refs.form});
                // this.buildingList = {...this.building};
            });
        },

        sliders() {
            this.$nextTick(() => {
                observer.publish('parametricfilterUpdate');
                this.updateFilter();
            });
        }
    },

    mounted() {
        this.subscribes();
        this.selected = this.$route.params.buildingId;

        this.$nextTick(() => {
            initSliders(this.$refs, this.sliders, this.parkingType,
                this.parkingType !== this.oldParkingType && this.oldParkingType !== null);
        });
    },


    methods: {
        ...mapActions(['changeFilterParking', 'resetFilter', 'updateFilter', 'parkingSend']),

        subscribes() {
            observer.subscribe('rangesliderFinish', () => {
                this.change();
            });

            observer.subscribe('selectorChange', ({id}) => {
                if (id) {
                    this.selected = id;
                }
            });
        },

        change() {
            const body = {
                step    : 'parking',
                type    : 'parkingFilter',
                floor   : this.$route.params.floorId || '',
                building: this.selected,
                form    : this.$refs.form

            };

            this.changeFilterParking(body);
        },

        reset() {
            $('#buildingSelection')
                .find('option:first-child')
                .prop('selected', true)
                .end()
                .trigger('chosen:updated')
                .change(() => {
                    this.$emit('selectChange');
                });
            this.resetFilter({type: 'reset'});
        },

        currentBuildingId() {
            return Number(this.$route.params.buildingId);
        },

        selectrichange() {
            const buildingId = Number(this.selected);

            if (buildingId === this.currentBuildingId()) {
                return;
            }

            const floors = Object.keys(this.filters.buildings).map((i) => {
                return {[i]: this.filters.buildings[i]};
            });

            let floorId = '';

            floors.forEach((item) => {
                for (const obj in item) {
                    if (Number(item[obj].id) === Number(buildingId)) {
                        floorId = item[obj].floorId;
                    }
                }
            });

            let url = this.$route.path.replace(/building[/]\d*/, `building/${buildingId}`);

            if (floorId) {
                url = url.replace(/floor[/]\d*/, `floor/${floorId}`);
            }

            this.$router.push(url);

            const body = {
                step    : 'parking',
                floor   : floorId || '',
                building: this.selected,
                cleanURL: true
            };

            this.parkingSend(body);
        }
    }

};

</script>
